import axios from 'axios'
import { extractError } from '../utils/errorHandler'

const handle = (err) => {
  const apiError = extractError(err)
  throw new Error(apiError.message || apiError.Message)
}

// Motivos ativos; com includeDeactivated, traz também os desativados
export const getAll = async (includeDeactivated = false) => {
  try {
    const params = includeDeactivated ? { include: 'deactivated' } : {}
    const { data } = await axios.get('scrapReason', { params })
    return data
  } catch (err) {
    return handle(err)
  }
}

// Motivos ativos que valem para a estação da ordem (vinculados a ela, à área dela ou gerais)
export const getForWorkOrder = async (workOrderId) => {
  try {
    const { data } = await axios.get('scrapReason', { params: { workOrderId } })
    return data
  } catch (err) {
    return handle(err)
  }
}

export const create = async (scrapReason) => {
  try {
    const { data } = await axios.post('scrapReason', scrapReason)
    return data
  } catch (err) {
    return handle(err)
  }
}

export const update = async (scrapReason) => {
  try {
    const { data } = await axios.put(`scrapReason/${scrapReason.id}`, scrapReason)
    return data
  } catch (err) {
    return handle(err)
  }
}

export const activate = async (id) => {
  try {
    await axios.post(`scrapReason/${id}/activate`)
  } catch (err) {
    handle(err)
  }
}

export const deactivate = async (id) => {
  try {
    await axios.post(`scrapReason/${id}/deactivate`)
  } catch (err) {
    handle(err)
  }
}
